import { general } from "./general";
import { products } from "./products";
import {categories} from "./categories";
import {coupons} from "./coupons";
import orders from "./orders";
import menus from "./menus";
import clients from "./clients";

export const translations = {
  ...products,
  ...categories,
  ...general,
  ...coupons,
  ...orders,
  ...menus,
  ...clients,
}



// WEBPACK FOOTER //
// ./locales/en_US/index.js